import React, { FC } from 'react';
import { FaTrash } from 'react-icons/fa';
import { IconProps } from './common/iconProps';

export const TrashIcon:
FC<IconProps> = ({ className }) => <FaTrash className={className} />;
